export default __webpack_public_path__ + "static/data-be45c29afa7950c3bd1e4c59d298a4fe.png";